/**
 * @fileoverview GET handler for the "/alloys/:partner/cohort_import/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { alloysPartnerCohortImportAppGroupId } from "./constants";
import type {
  GetAlloysPartnerCohortImportAppGroupIdProps,
  GetAlloysPartnerCohortImportAppGroupIdResult,
} from "./types";
import { isGetAlloysPartnerCohortImportAppGroupIdResult } from "./validators";

export const getAlloysPartnerCohortImportAppGroupId = reactQueryFetcherAdapter(
  alloysPartnerCohortImportAppGroupId,
  (
    signal: AbortSignal,
    { partner, appGroupId }: GetAlloysPartnerCohortImportAppGroupIdProps
  ): Promise<GetAlloysPartnerCohortImportAppGroupIdResult> => {
    return fetch(`/alloys/${partner}/cohort_import/${appGroupId}`, "GET", {}, { signal });
  },
  isGetAlloysPartnerCohortImportAppGroupIdResult
);
